<template>
  <div>
    <LoadingModal :show="loading" :label="loadingLabel" :overlay="true" />


    <div class="give-breath">
      <h2 aria-label="O bazi">О бази</h2>
      <p class="intro-text">
        <span>База Удружења новинара Србије о пројектном суфинансирању производње медијских садржаја настала је као
          резултат УНС-овог праћења расподеле буџетских средстава медијима од усвајања Закона о јавном информисању и
          медијима 2014. године, по којима се држава обавезала да изађе из власништва у медијима и да медијске садржаје
          од јавног значаја суфинансира путем јавних конкурса. </span><br><br>
        <span>База омогућава увид у то који су пројекти добили средства, који медији их реализују, колики износ је
          додељен, као и приступ оригиналним документима – конкурсима, решењима о избору комисија, одлукама о расподели
          средстава, примедбама на конкурсе и др. Доступни су и статистички подаци и инфографици по годинама, медијима,
          учесталости добијања средстава и износима који су за то издвојени. </span><br><br>
        <span>База покрива период од 2015. године до данас и редовно се ажурира, чиме олакшава праћење расподеле јавног
          новца и помаже у идентификовању неправилности у систему пројектног суфинансирања.</span>
        <span class="mobileview"> <br />За најбољи приказ на мобилним уређајима, окрените телефон у режим пејзажа
          (landscape)
          <img src="@/assets/Rotate-to-landscape.gif" alt="Rotate Device" />
        </span>
      </p>
    </div>
    <form action="">
      <fieldset class="fieldset">
        <legend class="fieldset-legend">Претрага</legend>
        <fieldset class="radio-group">
          <legend>Изаберите начин претраге</legend>

          <label :class="{ selected: activeSearch === 'contest' }" class="custom-radio">
            <input type="radio" name="searchType" value="contest" v-model="activeSearch" />
            <span class="radio-indicator"></span>
            Претрага по конкурсима
          </label>

          <label :class="{ selected: activeSearch === 'ai' }" class="custom-radio">
            <input type="radio" name="searchType" value="ai" v-model="activeSearch" />
            <span class="radio-indicator"></span>
            АИ претрага
          </label>
        </fieldset>
        <!-- AI Search -->
        <div class="ai-search" v-show="activeSearch === 'ai'">
          <input v-model="aiInput" placeholder="Унесите текст за претрагу" />
          <a href="#BrainSearchResults" class="button" @click.prevent="activateAiSearch">
            {{ aiLoading ? 'Претрага у току...' : 'АИ Претрага' }}
          </a>
        </div>

        <!-- Contest Grid -->
        <div class="grid" v-show="activeSearch === 'contest'">
          <div class="grid-cell u-full u-xmed-auto fieldset-item">
            <label for="township" class="fieldset-label">Изаберите јединицу</label>
            <VueSelect v-model="selectedTownship" label="name" :options="townships" class="custom-select">
              <template v-slot:no-options>Нема резултата за унету претрагу!</template>
            </VueSelect>
          </div>

          <div class="grid-cell u-full u-small-1of2 u-xmed-auto fieldset-item">
            <label for="date-from" class="fieldset-label">Датум од</label>
            <VueDatePicker v-model="safeDate.from" :minDate="new Date(2015, 0, 1)" :format="'dd.MM.yyyy.'"
              :enable-time-picker="false" :auto-apply="true" locale="sr" placeholder="Од датума"
              input-class-name="input" />
          </div>

          <div class="grid-cell u-full u-small-1of2 u-xmed-auto fieldset-item">
            <label for="date-to" class="fieldset-label">Датум до</label>
            <VueDatePicker v-model="safeDate.to" :minDate="new Date(2015, 0, 1)" :format="'dd.MM.yyyy.'"
              :enable-time-picker="false" :auto-apply="true" locale="sr" placeholder="До датума"
              input-class-name="input" />
          </div>

          <div class="grid-cell u-full u-xmed-auto fieldset-item fieldset-item--noLabel">
            <button @click.stop.prevent="submit" class="button">Тражи</button>
          </div>
        </div>
        <div class="secondary-search give-breath">
          <span>Остале врсте претрага</span>
          <ul class="contest-links">
            <!-- <li class="contest-links-item">
              <a href="/pretraga/mediji" class="link">Претрага по називу медија <span></span></a>
            </li> -->
            <li class="contest-links-item">
              <a href="/pretraga/podnosioc-projekta" class="link">Претрага по подносиоцу пројекта <span></span></a>
            </li>
            <li class="contest-links-item">
              <a href="/pretraga/komisija" class="link">Претрага по комисији <span></span></a>
            </li>
          </ul>
        </div>
      </fieldset>
    </form>

    <div class="contest-results" v-show="activeSearch === 'contest'">
      <a id="t"></a>
      <h2 v-if="searchPerformed || route?.params?.id">{{ headerText }}</h2>
      <div v-if="searchPerformed && !loading && data.length === 0">
        Нема резултата
      </div>
      <div v-if="data && data.length" class="results">


        <!-- <div v-if="$route.query.jedinica === 'all'" class="table-wrap"> -->
        <div v-if="$route.query.jedinica === 'all'" class="table-wrap">
          <table class="table  sticky-header">
            <tbody>
              <tr class="table-row">
                <th class="table-cell sortable" @click="setSort('township.name')">
                  Општине
                  <SortArrow :active="sortKey === 'township.name'" :asc="sortAsc" />
                </th>
                <th class="table-cell sortable" @click="setSort('calendar')">
                  Датум
                  <SortArrow :active="sortKey === 'calendar'" :asc="sortAsc" />
                </th>
                <th class="table-cell sortable" @click="setSort('competition_published')">
                  Да ли је расписан конкурс?
                  <SortArrow :active="sortKey === 'competition_published'" :asc="sortAsc" />
                </th>
                <th class="table-cell sortable" @click="setSort('competition_regular')">
                  Да ли је конкурс исправан?
                  <SortArrow :active="sortKey === 'competition_regular'" :asc="sortAsc" />
                </th>
                <!-- <th class="table-cell sortable" @click="setSort('mk_remarks')">
                  Да ли је МК упутила примедбе?
                  <SortArrow :active="sortKey === 'mk_remarks'" :asc="sortAsc" />
                </th>
                <th class="table-cell sortable" @click="setSort('mk_users')">
                  Да ли је МК предложила чланове комисије
                  <SortArrow :active="sortKey === 'mk_users'" :asc="sortAsc" />
                </th>
                <th class="table-cell sortable" @click="setSort('traveling_costs')">
                  Да ли је орган обезбедио путне трошкове?
                  <SortArrow :active="sortKey === 'traveling_costs'" :asc="sortAsc" />
                </th> -->
                <th class="table-cell sortable" @click="setSort('project_total')">
                  Колико је укупно пријављених пројеката?
                  <SortArrow :active="sortKey === 'project_total'" :asc="sortAsc" />
                </th>
                <th class="table-cell sortable" @click="setSort('granted_projects')">
                  Колико је укупно одобрених пројеката?
                  <SortArrow :active="sortKey === 'granted_projects'" :asc="sortAsc" />
                </th>
              </tr>
              <tr v-for="(contest, ind) in sortedContests" :key="ind" class="table-row">
                <td class="table-cell"><router-link :to="`/?jedinica=${contest.township?.id}#t`">{{ contest.township?.name || '-'
                }}</router-link></td>
                <!-- <td class="table-cell">{{ contest.township?.name || '-' }}</td> -->
                <td class="table-cell"><router-link :to="`/konkurs/${contest.contestid}/?jedinica=${contest.township?.id}#t`">{{ contest.calendar || '-' }}</router-link></td>
                <td class="table-cell">{{ contest.competition_published || '-' }}</td>
                <td class="table-cell">{{ contest.competition_regular || '-' }}</td>
                <!-- <td class="table-cell">{{ contest.mk_remarks || '-' }}</td>
                <td class="table-cell">{{ contest.mk_users || '-' }}</td>
                <td class="table-cell">{{ contest.traveling_costs || '-' }}</td> -->
                <td class="table-cell">{{ contest.project_total || '-' }}</td>
                <td class="table-cell">{{ contest.granted_projects || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else-if="$route.params.id" ref="detailSection">
          <ContestIndividual :contest="contests.length ? contests[0] : {}" />
        </div>

        <tabs v-else-if="contests && contests.length" :options="{ useUrlFragment: false }">
          <tab v-for="(contest, ind) in contests" :key="ind" :name="`${ind + 1}. ${contest.title}`">
            <ContestIndividual :contest="contest" />
          </tab>
        </tabs>
      </div>
      <div class="column">
        <PublicStatisticsYearly></PublicStatisticsYearly>
      </div>
    </div>
    <div class="AI-search-results" v-show="activeSearch === 'ai'">
      <a id="BrainSearchResults"></a>
      <BrainSearch :search-query="aiInput" :search-trigger="searchTrigger" />
    </div>
  </div>


</template>

<script src="./Contest.js"></script>

<style scoped>
.brainInput {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  height: 40px;
  font-size: 14px;
  font-weight: bolder;
}

/* Your styles here (unchanged) */
.two-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  padding: 20px;
}

.centerStats {
  padding-top: 50px;
  text-align: center;
  margin: 0 auto;
}

.chart-block {
  padding-top: 15px;
}

@media (max-width: 768px) {
  .two-columns {
    grid-template-columns: 1fr;
  }
}

.column {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.chart-wrapper {
  max-width: 100%;
  width: 100%;
  height: 300px;
  position: relative;
}

canvas {
  width: 100% !important;
  height: 100% !important;
}

.table-cell.sortable {
  cursor: pointer;
  user-select: none;
}

/* */
/* AI Search input */
input {
  width: 100%;
  max-width: 400px;
  /* optional max width */
  padding: 1rem;
  /* comfortable spacing */
  font-size: 1rem;
  line-height: 1rem;
  border-radius: var(--radius);
  /* smooth corners */
  border: 1px solid var(--csBorder);
  /* soft border */
  background: var(--csWhite);
  /* subtle background */
  color: var(--csGray);
  outline: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  /* subtle depth */
  transition: all 0.25s ease-in-out;
}

/* Placeholder styling */
input::placeholder {
  color: #9CA3AF;
  /* neutral gray */
  opacity: 1;
  /* ensure visibility */
}

/* Focus effect */
input:focus {
  border-color: var(--csBlue);
  /* accent border */
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
  /* soft highlight */
  background: white;
  /* pop up on focus */
}

.ai-search {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-block: 2.5rem;

  @media all and (min-width: 768px) {
    flex-direction: row;
  }
}

.ai-search input {
  max-width: 100%;

  @media all and (min-width: 768px) {
    max-width: 400px;
  }
}
</style>
